import { Card, Grid, Link, ReadOnlySection } from '@cxc/react-fpds-components';
import TabSectionProps from '../../../types/props/TabSectionProps';
import { OverviewSectionType, ReadOnlySectionItemType } from '../../../types/TabSectionTypes';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);

export const OverviewPanel = ({ incentive }: TabSectionProps) => {
    const formatDate = (date: string) => {
        return dayjs(date).format('MM/DD/YYYY');
    };

    const createEmailLink = (contactInfo: string) => {
        const emailRegex =
            /[a-z0-9_-]([a-z0-9._+-]){0,63}@[a-z0-9-]([a-z0-9._-]){1,255}(\.[a-z]{2,10})/gi;
        const emailMatch = contactInfo.match(emailRegex);
        if (emailMatch) {
            const email = emailMatch[0];
            const parts = contactInfo.split(email);
            return (
                <span>
                    {parts[0]}
                    <Link to={`mailto:${email}`} size="small" target="_blank" disabled={false}>
                        {email}
                    </Link>
                    {parts[1]}
                </span>
            );
        }
        return contactInfo;
    };

    const overviewSections: OverviewSectionType[] = [
        {
            gridItemConfiguration: { responsiveConfiguration: { xl: 9, l: 9, m: 12, s: 12 } },
            cardConfiguration: {
                title: 'OVERVIEW',
                size: 'large',
                ratio: '16/9',
                cardType: 'default',
                orientation: 'vertical',
            },
            contents: [
                {
                    title: '',
                    columnOptions: { xl: 12, l: 12, m: 12, s: 12 },
                    items: [
                        { title: 'Name', content: incentive.incentiveName },
                        { title: 'Description', content: incentive.incentiveDescription },
                        { title: 'Scope', content: incentive.incentiveScopeDescription },
                    ],
                },
            ],
        },
        {
            gridItemConfiguration: { responsiveConfiguration: { xl: 3, l: 3, m: 12, s: 12 } },
            cardConfiguration: {
                title: 'GRANTOR DETAILS',
                size: 'large',
                ratio: '16/9',
                cardType: 'default',
                orientation: 'vertical',
            },
            contents: [
                {
                    title: '',
                    hasEmail: true,
                    columnOptions: { xl: 12, l: 12, m: 12, s: 12 },
                    items: [
                        ...(incentive?.startDate
                            ? [
                                  {
                                      title: 'Application Window',
                                      content: formatDate(incentive.startDate),
                                  },
                              ]
                            : []),
                        ...(incentive?.incentiveProgramContactInfo
                            ? [
                                  {
                                      title: 'Contact Info',
                                      content: createEmailLink(
                                          incentive.incentiveProgramContactInfo,
                                      ),
                                  },
                              ]
                            : []),
                    ],
                },
            ],
        },
    ];

    return (
        <Grid data-testId="overview-panel">
            {overviewSections.map((overviewSection) => (
                <Grid.Item
                    key={overviewSection.cardConfiguration.title}
                    xl={overviewSection.gridItemConfiguration.responsiveConfiguration.xl}
                    l={overviewSection.gridItemConfiguration.responsiveConfiguration.l}
                    m={overviewSection.gridItemConfiguration.responsiveConfiguration.m}
                    s={overviewSection.gridItemConfiguration.responsiveConfiguration.s}
                >
                    <Card
                        cardType={overviewSection.cardConfiguration.cardType}
                        orientation={overviewSection.cardConfiguration.orientation}
                        ratio={overviewSection.cardConfiguration.ratio}
                        titleProp={{
                            title: overviewSection.cardConfiguration.title,
                            size: overviewSection.cardConfiguration.size,
                        }}
                    >
                        {overviewSection.contents.map((content: any) => (
                            <div key={content.title}>
                                <ReadOnlySection
                                    header={{
                                        title: content.title,
                                    }}
                                    columnOptions={content.columnOptions}
                                    className="read-only-section"
                                    variant="SuperCondensed"
                                >
                                    {content.items.map((item: ReadOnlySectionItemType) => (
                                        <ReadOnlySection.Item
                                            key={item.title}
                                            label={item.title}
                                            // @ts-expect-error - Value needs to expect JSX inorder to render email as a Link
                                            value={item.content}
                                        />
                                    ))}
                                </ReadOnlySection>
                            </div>
                        ))}
                    </Card>
                </Grid.Item>
            ))}
        </Grid>
    );
};
